import { Component, OnInit } from '@angular/core';
import { IClockNumber, IDisplayPreference, TimePickerConfig } from '../definitions';
import { AtpCoreService } from '../atp-core.service';
import { ITime } from '../definitions';
export class TimePickerComponent implements OnInit {

  _ref: any;
public subject: any = null;
public activeModal = false;
public timerElement: any;
public clockObject: Array<any>;
public isClicked: boolean;
public clockType: 'minute' | 'hour' = 'hour';
public time: ITime = {
    ampm: 'AM',
    minute: 0,
    hour: 12
  };
public nowTime: any = this.time.hour;
public degree: any;
public config: TimePickerConfig;
public appRef: any;
public isPopup = true;
public allowed: any;
public preference: IDisplayPreference;
public changeToMin: boolean;
private animationTime = 0;
/**
 * @param {?} core
 */
constructor(
private core: AtpCoreService
  ) { }
/**
 * @param {?} time
 * @return {?}
 */
public ParseStringToTime (time: string): void {
    time = (time === '' || time === undefined || time === null) ? this.time.hour + ':' + this.time.minute : time;
    this.time = this.core.StringToTime(time);
  }
/**
 * @return {?}
 */
public GetTime () {
    const /** @type {?} */ time = this.core.TimeToString(this.time);
    this.subject.next(time);
  }

  clockMaker = () => {
    const /** @type {?} */ type = this.clockType;
    this.clockObject = this.core.ClockMaker(type);
    this.setArrow(null);
  }

  setActiveTime = () => {
    this.nowTime = (this.clockType === 'minute' ? this.time.minute : this.time.hour);
  }

  setArrow = (obj: any) => {
    if (obj) {
      this.clockType = obj.type;
      if (this.clockType === 'minute') {
        this.time.minute = obj.time;
      } else {
        this.time.hour = obj.time;
      }
    }
    const /** @type {?} */ step = (this.clockType === 'minute') ? 6 : 30;
    const /** @type {?} */ time = (this.clockType === 'minute') ? this.time.minute : this.time.hour;
    const /** @type {?} */ degrees = time * step;
    this.rotationClass(degrees);
    this.setActiveTime();
  }

  rotationClass = (degrees: any) => {
    this.degree = degrees;
  }
/**
 * @return {?}
 */
setTime() {
    this.isClicked = false;
    if (this.config.changeToMinutes && !this.config.onlyHour && this.clockType === 'hour') {
      this.ChangeAnimational('minute');
    }
  }

  getDegree = (ele: any) => {
    const /** @type {?} */ step = this.clockType === 'minute' ? 6 : 30;
    const /** @type {?} */ parrentPos = ele.currentTarget.getBoundingClientRect();
    if (this.isClicked && (ele.currentTarget === ele.target || ele.target.nodeName === 'BUTTON')) {
      const /** @type {?} */ clock = {
        width: ele.currentTarget.offsetWidth,
        height: ele.currentTarget.offsetHeight
      };
      const /** @type {?} */ degrees = this.core.CalcDegrees(ele, parrentPos, step);
      let /** @type {?} */ hour = this.time.hour, /** @type {?} */
          minute = this.time.minute;

      if (this.clockType === 'hour') {
        hour = (degrees / step);
        hour = (hour > 12) ? hour - 12 : hour;
      } else if (this.clockType === 'minute') {
        minute = (degrees / step);
        minute = (minute > 59) ? minute - 60 : minute;
      }

      const /** @type {?} */ min = this.config.rangeTime.start, /** @type {?} */
            max = this.config.rangeTime.end;

      const /** @type {?} */ nowMinHour = +min.split(':')[0] < 12 ? +min.split(':')[0] : +min.split(':')[0] - 12;
      const /** @type {?} */ nowMaxHour = +max.split(':')[0] < 12 ? +max.split(':')[0] : +max.split(':')[0] - 12;
      const /** @type {?} */ nowMinMin = +min.split(':')[1];
      const /** @type {?} */ nowMaxMin = +max.split(':')[1];

      const /** @type {?} */ nowTime = this.GetNowTime(hour, this.time.ampm, minute);
      if (this.allowed.indexOf(nowTime) > -1) {
        this.time.hour = hour;
        this.time.minute = minute;
        this.rotationClass(degrees);
        this.setActiveTime();
      }else if (this.clockType === 'hour' && (hour === nowMinHour && minute <= nowMinMin)) {
        this.time.hour = nowMinHour;
        this.time.minute = nowMinMin;
      }else if (this.clockType === 'hour' && (hour === nowMaxHour && minute >= nowMaxMin)) {
        this.time.hour = nowMaxHour;
        this.time.minute = nowMaxMin;
      }
    }
  }
/**
 * @param {?} hour
 * @param {?} ampm
 * @param {?} minute
 * @return {?}
 */
private GetNowTime (hour: number, ampm: 'AM' | 'PM', minute: number): string {
    const /** @type {?} */ Hour = (hour === 12 && ampm === 'AM') ? '0' : hour;
    const /** @type {?} */ nowTime = Hour + ':' + minute + ' ' + ampm;
    return nowTime;
  }
/**
 * @return {?}
 */
checkBet() {
    const /** @type {?} */ nowTime = this.GetNowTime(this.time.hour, this.time.ampm, this.time.minute);
    if (this.allowed.indexOf(nowTime) === -1) {
      this.ParseStringToTime(this.config.rangeTime.start);
      this.setArrow(null);
      this.setActiveTime();
    }
  }
/**
 * @return {?}
 */
modalAnimation() {
    setTimeout(() => {
      this.activeModal = true;
    }, 1);
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.allowed = this.core.allowedTimes (this.config.rangeTime.start, this.config.rangeTime.end);
    if (this.config && this.config.onlyMinute) {
      this.clockType = 'minute';
    }
    if (this.config) {
      if (this.config.onlyPM) {
        this.time.ampm = 'PM';
      } else if (this.config.onlyAM) {
        this.time.ampm = 'AM';
      }
    }
    this.clockMaker();
    this.modalAnimation();
  }
/**
 * @return {?}
 */
public MinuteClick () {
    /**
     * We are not permitting user to select the minute.
     * but anyway, it will return the standard time, if provided the default time.
     */
    if (this.config && this.config.onlyHour) {
      return false;
    }

    this.ChangeAnimational('minute');
  }
/**
 * @return {?}
 */
public HourClick () {
    /**
     * We are not permitting user to select the minute.
     * but anyway, it will return the standard time, if provided the default time.
     */
    if (this.config && this.config.onlyMinute) {
      return false;
    }
    this.ChangeAnimational('hour');
  }
/**
 * @param {?} type
 * @return {?}
 */
ChangeAnimational(type: 'minute' | 'hour') {
    if (this.clockType !== type) {
      if (this.config.animation === 'fade') {
        this.changeToMin = true;
        setTimeout(() => {
          this.changeToMin = false;
          this.clockType = type;
          this.clockMaker();
        }, 200);
      } else if (this.config.animation === 'rotate') {
        this.animationTime = 0.4;
        this.clockType = type;
        this.clockMaker();
      } else {
        this.clockType = type;
        this.clockMaker();
      }
    }
  }
/**
 * @return {?}
 */
SetAM () {
    if (this.config && this.config.onlyPM) {
      return false;
    }
    this.time.ampm = 'AM';
    this.checkBet();
  }
/**
 * @return {?}
 */
SetPM () {
    if (this.config && this.config.onlyAM) {
      return false;
    }
    this.time.ampm = 'PM';
    this.checkBet();
  }
/**
 * @param {?} e
 * @return {?}
 */
Close(e: any) {
    if (e.target === e.currentTarget) {
      if (this.isPopup === true) {
        this.activeModal = false;
        setTimeout(() => {
          this.appRef.detachView(this._ref.hostView);
          this._ref.destroy();
        }, 400);
      }
    }
  }
/**
 * @return {?}
 */
getClockArrowStyle() {
    let /** @type {?} */ arrowStyle = {};
    if (this.config.animation === 'rotate') {
        arrowStyle = {
          transform: 'rotate(' + this.degree + 'deg)',
          '-webkit-transform': 'rotate(' + this.degree + 'deg)',
          background: this.config.arrowStyle.background,
          '-webkit-transition': 'transform ' + this.getAnimationTime(),
          transition: 'transform ' + + this.getAnimationTime()
        };
    }else {
      arrowStyle = {
        transform: 'rotate(' + this.degree + 'deg)',
        '-webkit-transform': 'rotate(' + this.degree + 'deg)',
        background: this.config.arrowStyle.background,
      };
    }
    return arrowStyle;
  }
/**
 * @return {?}
 */
getAnimationTime() {
    return this.animationTime + 's';
  }
/**
 * Event on clock mouse click down
 * @param {?} event - captured event
 * @return {?}
 */
updateClockDown(event) {
    this.isClicked = true;
    this.animationTime = 0;
    this.getDegree(event);
  }
/**
 * @return {?}
 */
setNewRotation() {
    const /** @type {?} */ targetDegree = ((this.time.minute / 60) * 360) + 360;
    const /** @type {?} */ targetDegree2 = targetDegree * 2;

    const /** @type {?} */ diff1 = Math.abs(this.degree - targetDegree);
    const /** @type {?} */ diff2 = Math.abs(this.degree - targetDegree2);

    if (diff1 < diff2) {
      this.rotationClass(targetDegree);
    } else {
      this.rotationClass(targetDegree2);
    }
  }
/**
 * @return {?}
 */
public GetSeparator () {
    if (this.preference && this.preference.separator) {
      return this.preference.separator;
    }
    return ':';
  }
/**
 * @param {?} period
 * @return {?}
 */
public GetPeriod (period: 'AM' | 'PM') {
    if (this.preference && this.preference.period) {
      return this.preference.period(period);
    }
    return period;
  }
/**
 * @return {?}
 */
public GetMinute () {
    if (this.preference && this.preference.minute) {
      return this.preference.minute(this.time.minute);
    }
    let /** @type {?} */ min: string = this.time.minute.toString();
    if (+min < 10) {
      min = '0' + min;
    }
    return min;
  }
/**
 * @return {?}
 */
public GetHour () {
    if (this.preference && this.preference.hour) {
      return this.preference.hour(this.time.hour);
    }
    return this.time.hour;
  }
/**
 * @param {?} clock
 * @return {?}
 */
public GetClockTime(clock: IClockNumber) {
    if ( ! this.preference) {
      return clock.time;
    }
    if ( this.clockType === 'hour' && this.preference.clockHour) {
      return this.preference.clockHour(clock.time);
    }
    if ( this.clockType === 'minute' && this.preference.clockMinute) {
      return this.preference.clockMinute(clock.time);
    }
    return clock.time;
  }
/**
 * @param {?} key
 * @return {?}
 */
public GetLabel (key: string) {
    const /** @type {?} */ defaults = {
      'ok': 'Ok',
      'cancel': 'Cancel'
    };
    if ((this.preference && this.preference.labels && this.preference.labels.ok)) {
      defaults.ok = this.preference.labels.ok;
    }
    if ((this.preference && this.preference.labels && this.preference.labels.cancel)) {
      defaults.cancel = this.preference.labels.cancel;
    }
    return defaults[key];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'time-picker',
  template: `
    <div id="time-picker-wrapper" class="{{config.theme}}" [ngClass]="{'active': activeModal, 'static': !isPopup}" (click)="Close($event);">
      <div id="time-picker" [ngClass]="{'active': activeModal, 'static': !isPopup}">
        <div class="time-picker-header">
          <div class="time-picker-selected-time">
              <div class="time-picker-hour" (click)="HourClick()" [attr.disabled]="(config.onlyMinute) ? 'disabled' : null"
                [ngClass]="{'selected' : clockType == 'hour'}">{{GetHour()}}</div>
              <span class="time-seprator">{{GetSeparator()}}</span>
              <div class="time-picker-minute" (click)="MinuteClick();" [attr.disabled]="(config.onlyHour) ? 'disabled' : null"
                [ngClass]="{'selected' : clockType == 'minute'}">{{GetMinute()}}</div>
          </div>
          <div class="time-picker-selected-ampm">
            <div class="time-picker-am" (click)="SetAM();" [attr.disabled]="(config.onlyPM) ? 'disabled' : null" [ngClass]="{'selected' : time.ampm == 'AM'}">{{GetPeriod('AM')}}</div>
            <div class="time-picker-pm" (click)="SetPM();" [attr.disabled]="(config.onlyAM) ? 'disabled' : null" [ngClass]="{'selected' : time.ampm == 'PM'}">{{GetPeriod('PM')}}</div>

          </div>
        </div>
        <div class="time-picker-content">
            <div class="time-picker-clock" [ngClass]="{'hide-time-picker-clock': changeToMin}"  (mousemove)="getDegree($event);" (mousedown)="updateClockDown($event)" (mouseup)="setTime();">
              <button *ngFor="let clock of clockObject" [ngClass]="{'active' : nowTime == clock.time}" 
                [id]="'timepicker-item-id-' + clock.time" 
                [ngStyle]="{top: clock.top,left: clock.left, color: nowTime == clock.time ? config.arrowStyle.color :  '', background: nowTime == clock.time ? config.arrowStyle.background : 'transparent'}">
                {{GetClockTime(clock)}}
              </button>
              <div class="time-picker-clock-origin" [ngStyle]="{ background: config.arrowStyle.background}"></div>
              <div id="tpc-arrow" class="time-picker-clock-arrow" [ngStyle]="getClockArrowStyle()">
                <span [ngStyle]="{ background: config.arrowStyle.background }"></span>
              </div>
            </div>
        </div>
        <div class="time-picker-footer">
            <button (click)="Close($event);">{{GetLabel('cancel')}}</button>
            <button (click)="GetTime();Close($event);" class="atp-ref-dialog-close">{{GetLabel('ok')}}</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    #time-picker-wrapper {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: transparent;
      -webkit-transition: background 0.4s;
      transition: background 0.4s;
      font-family: 'Roboto', sans-serif;
      z-index: 1000; }
      #time-picker-wrapper.static {
        position: relative !important;
        background: transparent !important;
        display: inline-block;
        z-index: 0; }
      #time-picker-wrapper.active {
        background: rgba(0, 0, 0, 0.3); }
      #time-picker-wrapper.dark #time-picker {
        background: #424242; }
        #time-picker-wrapper.dark #time-picker .time-picker-header {
          border-bottom: none;
          background: #555555; }
          #time-picker-wrapper.dark #time-picker .time-picker-header .time-picker-selected-time {
            color: #999; }
            #time-picker-wrapper.dark #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.dark #time-picker .time-picker-header .time-picker-selected-ampm {
            color: #999; }
            #time-picker-wrapper.dark #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.dark #time-picker .time-picker-clock {
          background: #555555; }
          #time-picker-wrapper.dark #time-picker .time-picker-clock > button {
            color: #fff; }
        #time-picker-wrapper.dark #time-picker .time-picker-footer {
          border-top: none; }
          #time-picker-wrapper.dark #time-picker .time-picker-footer button {
            background: #555555;
            color: #fff; }
            #time-picker-wrapper.dark #time-picker .time-picker-footer button:hover {
              background: #777; }
      #time-picker-wrapper.light #time-picker {
        background: #fff; }
        #time-picker-wrapper.light #time-picker .time-picker-header {
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.light #time-picker .time-picker-header .time-picker-selected-time {
            color: #aaa; }
            #time-picker-wrapper.light #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #000; }
          #time-picker-wrapper.light #time-picker .time-picker-header .time-picker-selected-ampm {
            color: #aaa; }
            #time-picker-wrapper.light #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #000; }
        #time-picker-wrapper.light #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.light #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.light #time-picker .time-picker-clock > button.active {
              background: blue;
              color: #fff; }
          #time-picker-wrapper.light #time-picker .time-picker-clock .time-picker-clock-origin {
            background: blue; }
          #time-picker-wrapper.light #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: blue; }
            #time-picker-wrapper.light #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: blue; }
        #time-picker-wrapper.light #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.light #time-picker .time-picker-footer button {
            background: #f1f1f1; }
            #time-picker-wrapper.light #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper.material-green #time-picker {
        background: #fff; }
        #time-picker-wrapper.material-green #time-picker .time-picker-header {
          background-color: #00897b;
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-green #time-picker .time-picker-header .time-picker-selected-time {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-green #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.material-green #time-picker .time-picker-header .time-picker-selected-ampm {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-green #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.material-green #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.material-green #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.material-green #time-picker .time-picker-clock > button.active {
              background: #00897b;
              color: #fff; }
          #time-picker-wrapper.material-green #time-picker .time-picker-clock .time-picker-clock-origin {
            background: #00897b; }
          #time-picker-wrapper.material-green #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: #00897b; }
            #time-picker-wrapper.material-green #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: #00897b; }
        #time-picker-wrapper.material-green #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-green #time-picker .time-picker-footer button {
            font-weight: bold;
            text-transform: uppercase;
            background: transparent;
            color: #00897b; }
            #time-picker-wrapper.material-green #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper.material-blue #time-picker {
        background: #fff; }
        #time-picker-wrapper.material-blue #time-picker .time-picker-header {
          background-color: #3F51B5;
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-header .time-picker-selected-time {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-blue #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-header .time-picker-selected-ampm {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-blue #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.material-blue #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.material-blue #time-picker .time-picker-clock > button.active {
              background: #3F51B5;
              color: #fff; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-clock .time-picker-clock-origin {
            background: #3F51B5; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: #3F51B5; }
            #time-picker-wrapper.material-blue #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: #3F51B5; }
        #time-picker-wrapper.material-blue #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-blue #time-picker .time-picker-footer button {
            font-weight: bold;
            text-transform: uppercase;
            background: transparent;
            color: #3F51B5; }
            #time-picker-wrapper.material-blue #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper.material-red #time-picker {
        background: #fff; }
        #time-picker-wrapper.material-red #time-picker .time-picker-header {
          background-color: #F44336;
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-red #time-picker .time-picker-header .time-picker-selected-time {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-red #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.material-red #time-picker .time-picker-header .time-picker-selected-ampm {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-red #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.material-red #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.material-red #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.material-red #time-picker .time-picker-clock > button.active {
              background: #F44336;
              color: #fff; }
          #time-picker-wrapper.material-red #time-picker .time-picker-clock .time-picker-clock-origin {
            background: #F44336; }
          #time-picker-wrapper.material-red #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: #F44336; }
            #time-picker-wrapper.material-red #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: #F44336; }
        #time-picker-wrapper.material-red #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-red #time-picker .time-picker-footer button {
            font-weight: bold;
            text-transform: uppercase;
            background: transparent;
            color: #F44336; }
            #time-picker-wrapper.material-red #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper.material-purple #time-picker {
        background: #fff; }
        #time-picker-wrapper.material-purple #time-picker .time-picker-header {
          background-color: #9C27B0;
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-header .time-picker-selected-time {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-purple #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-header .time-picker-selected-ampm {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-purple #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.material-purple #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.material-purple #time-picker .time-picker-clock > button.active {
              background: #9C27B0;
              color: #fff; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-clock .time-picker-clock-origin {
            background: #9C27B0; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: #9C27B0; }
            #time-picker-wrapper.material-purple #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: #9C27B0; }
        #time-picker-wrapper.material-purple #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-purple #time-picker .time-picker-footer button {
            font-weight: bold;
            text-transform: uppercase;
            background: transparent;
            color: #9C27B0; }
            #time-picker-wrapper.material-purple #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper.material-orange #time-picker {
        background: #fff; }
        #time-picker-wrapper.material-orange #time-picker .time-picker-header {
          background-color: #FF9800;
          border-bottom: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-header .time-picker-selected-time {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-orange #time-picker .time-picker-header .time-picker-selected-time div.selected {
              color: #fff; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-header .time-picker-selected-ampm {
            color: rgba(255, 255, 255, 0.4); }
            #time-picker-wrapper.material-orange #time-picker .time-picker-header .time-picker-selected-ampm div.selected {
              color: #fff; }
        #time-picker-wrapper.material-orange #time-picker .time-picker-clock {
          background: #ededed; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-clock > button {
            color: #000; }
            #time-picker-wrapper.material-orange #time-picker .time-picker-clock > button.active {
              background: #FF9800;
              color: #fff; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-clock .time-picker-clock-origin {
            background: #FF9800; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-clock .time-picker-clock-arrow {
            background: #FF9800; }
            #time-picker-wrapper.material-orange #time-picker .time-picker-clock .time-picker-clock-arrow span {
              background: #FF9800; }
        #time-picker-wrapper.material-orange #time-picker .time-picker-footer {
          border-top: 1px solid #e1e1e1; }
          #time-picker-wrapper.material-orange #time-picker .time-picker-footer button {
            font-weight: bold;
            text-transform: uppercase;
            background: transparent;
            color: #FF9800; }
            #time-picker-wrapper.material-orange #time-picker .time-picker-footer button:hover {
              background: #ddd; }
      #time-picker-wrapper #time-picker {
        width: 325px;
        height: auto;
        -webkit-box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
                box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
        border-radius: 2px;
        margin: 15vh auto !important;
        -webkit-transform: scale(0.5) !important;
                transform: scale(0.5) !important;
        -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
        transition: opacity 0.3s, -webkit-transform 0.3s;
        transition: transform 0.3s, opacity 0.3s;
        transition: transform 0.3s, opacity 0.3s, -webkit-transform 0.3s;
        opacity: 0; }
        #time-picker-wrapper #time-picker.static {
          margin: 0px !important;
          -webkit-box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 0 7px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
                  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 0 7px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12); }
        #time-picker-wrapper #time-picker.active {
          -webkit-transform: scale(1) !important;
                  transform: scale(1) !important;
          opacity: 1; }
        #time-picker-wrapper #time-picker .time-picker-header {
          text-align: center;
          padding: 15px 0px; }
          #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-time {
            font-size: 35px;
            padding: 5px 0px; }
            #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-time div {
              display: inline-block;
              cursor: pointer; }
              #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-time div[disabled=true] {
                cursor: default; }
          #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-ampm {
            font-size: 18px; }
            #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-ampm div {
              display: inline-block;
              padding: 0 5px;
              cursor: pointer; }
              #time-picker-wrapper #time-picker .time-picker-header .time-picker-selected-ampm div[disabled=true] {
                cursor: default; }
        #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock {
          width: 200px;
          height: 200px;
          padding: 24px;
          border-radius: 50%;
          cursor: pointer;
          margin: 25px auto;
          position: relative;
          user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          -webkit-user-select: none;
          opacity: 1;
          -webkit-transform: scale(1);
                  transform: scale(1);
          -webkit-transition: opacity 0.3s, transform 0.3s;
          -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
          transition: opacity 0.3s, -webkit-transform 0.3s;
          transition: opacity 0.3s, transform 0.3s;
          transition: opacity 0.3s, transform 0.3s, -webkit-transform 0.3s; }
          #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock button {
            border: none;
            position: absolute;
            width: 35px;
            height: 35px;
            border-radius: 50%;
            cursor: pointer;
            font-size: 17px;
            text-align: center;
            padding: 0;
            -webkit-transition: all .2s;
            transition: all .2s;
            z-index: 3; }
          #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock .time-picker-clock-origin {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -3px;
            margin-top: -3px; }
          #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock .time-picker-clock-arrow {
            width: 2px;
            height: 41%;
            position: absolute;
            left: 0;
            top: 22px;
            right: 0;
            margin: auto;
            -webkit-transform-origin: top left;
            transform-origin: bottom; }
            #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock .time-picker-clock-arrow span {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              position: absolute;
              top: 0;
              right: -3px; }
          #time-picker-wrapper #time-picker .time-picker-content .time-picker-clock.hide-time-picker-clock {
            opacity: 0;
            -webkit-transform: scale(0.8);
                    transform: scale(0.8); }
        #time-picker-wrapper #time-picker .time-picker-footer {
          padding: 15px;
          text-align: right; }
          #time-picker-wrapper #time-picker .time-picker-footer button {
            border: transparent;
            margin-left: 10px;
            padding: 10px;
            font-size: 14px;
            border-radius: 2px;
            cursor: pointer; }

    * {
      outline: none;
      -webkit-box-sizing: content-box;
              box-sizing: content-box; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AtpCoreService, },
];
}

function TimePickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
TimePickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimePickerComponent.ctorParameters;
/** @type {?} */
TimePickerComponent.prototype._ref;
/** @type {?} */
TimePickerComponent.prototype.subject;
/** @type {?} */
TimePickerComponent.prototype.activeModal;
/** @type {?} */
TimePickerComponent.prototype.timerElement;
/** @type {?} */
TimePickerComponent.prototype.clockObject;
/** @type {?} */
TimePickerComponent.prototype.isClicked;
/** @type {?} */
TimePickerComponent.prototype.clockType;
/** @type {?} */
TimePickerComponent.prototype.time;
/** @type {?} */
TimePickerComponent.prototype.nowTime;
/** @type {?} */
TimePickerComponent.prototype.degree;
/** @type {?} */
TimePickerComponent.prototype.config;
/** @type {?} */
TimePickerComponent.prototype.appRef;
/** @type {?} */
TimePickerComponent.prototype.isPopup;
/** @type {?} */
TimePickerComponent.prototype.allowed;
/** @type {?} */
TimePickerComponent.prototype.preference;
/** @type {?} */
TimePickerComponent.prototype.changeToMin;
/** @type {?} */
TimePickerComponent.prototype.animationTime;
/** @type {?} */
TimePickerComponent.prototype.clockMaker;
/** @type {?} */
TimePickerComponent.prototype.setActiveTime;
/** @type {?} */
TimePickerComponent.prototype.setArrow;
/** @type {?} */
TimePickerComponent.prototype.rotationClass;
/** @type {?} */
TimePickerComponent.prototype.getDegree;
/** @type {?} */
TimePickerComponent.prototype.core;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
